import { AfterViewInit, ChangeDetectionStrategy, Component, DestroyRef, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { KiService, NavigationDTO } from '../ki.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { delay } from 'rxjs';
import { RoutingID } from '../../../routes/sb-routing-enum';
import { isEnumValue } from '../../../services/global/global-methods';

@Component({
  selector: 'sb-comp-ki-history',
  standalone: false,
  templateUrl: './ki-history.component.html',
  styleUrl: './ki-history.component.scss',
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KiHistoryComponent implements OnInit, AfterViewInit {
  protected readonly kiService = inject(KiService);
  protected readonly destroyRef = inject(DestroyRef);

  @ViewChild('historyContainer') historyContainer!: ElementRef<HTMLDivElement>;

  ngOnInit() {}

  ngAfterViewInit() {
    // Scroll to bottom when first messages arrive or new ones are added
    this.kiService.scrollBottom$.pipe(delay(50), takeUntilDestroyed(this.destroyRef)).subscribe(shouldScroll => {
      queueMicrotask(() => {
        if (shouldScroll) {
          this.scrollToBottomIfNeeded();
        }
      });
    });
  }

  onScroll() {
    const el = this.historyContainer.nativeElement;
    if (el.scrollTop === 0) {
      const prevHeight = el.scrollHeight;
      this.kiService.loadOlder();
      // after messages update, keep viewport on same message
      setTimeout(() => {
        const newHeight = el.scrollHeight;
        el.scrollTop = newHeight - prevHeight;
      });
    }
  }

  private scrollToBottomIfNeeded() {
    const el = this.historyContainer.nativeElement;
    const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 40;
    if (!atBottom) {
      el.scroll({ behavior: 'smooth', top: el.scrollHeight });
    }
  }

  protected transformOrInvalidateNavigationDTO(navigationObj: NavigationDTO): NavigationDTO {
    if (!navigationObj || !isEnumValue(RoutingID, navigationObj.routingId)) {
      return null;
    }
    const result: NavigationDTO = { ...navigationObj };
    // potentially check qp for "variable" value
    for (let [qpKey, qpValue] of Object.entries(result.queryParameter)) {
      if (typeof qpValue !== 'string') {
        qpValue = JSON.stringify(qpValue);
        result.queryParameter[qpKey] = qpValue;
      }
    }
    return result;
  }

  protected checkForValidNavigationDTOs(navigations: NavigationDTO[]): NavigationDTO[] {
    return navigations?.map(nav => this.transformOrInvalidateNavigationDTO(nav)).filter(nav => nav !== null) ?? [];
  }
}
